import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "fi-icon-custom-folder-open",
  "use": "fi-icon-custom-folder-open-usage",
  "viewBox": "0 0 18 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 12\" id=\"fi-icon-custom-folder-open\">\n    <path fill=\"#96d0fc\" d=\"M17.9 71.128l-2.263 3.88a2 2 0 0 1-1.731.992H1.407a.75.75 0 0 1-.648-1.128l2.263-3.88A2 2 0 0 1 4.75 70h12.5a.75.75 0 0 1 .65 1.128zM4.75 69H15v-1.5a1.5 1.5 0 0 0-1.5-1.5h-5l-2-2h-5A1.5 1.5 0 0 0 0 65.5v8.689l2.159-3.7A3.01 3.01 0 0 1 4.75 69z\" transform=\"translate(0 -64)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol